import { render, staticRenderFns } from "./DocumentLabel.vue?vue&type=template&id=df227620&scoped=true&"
import script from "./DocumentLabel.vue?vue&type=script&lang=js&"
export * from "./DocumentLabel.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_annotations.scss?vue&type=style&index=0&id=df227620&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df227620",
  null
  
)

export default component.exports